import React, { Component } from 'react'

import {
    Grid, Button, Dialog, DialogTitle,
    DialogContent, DialogActions, FormControlLabel, Checkbox
} from '@material-ui/core'


class AddOnModal extends Component {

    state = {
        addOns: {},
        totalItems: 0,
        priceWithAddons: 0
    }

    clearState = () => {
        this.setState({
            addOns: {},
            totalItems: 0,
            priceWithAddons: 0
        })
    }


    toggleAddOn = (addOn) => {
        const selectedAddOns = this.state.addOns
        if (selectedAddOns.hasOwnProperty(addOn.id)) {
            delete selectedAddOns[addOn.id]

            this.setState({
                addOns: { ...selectedAddOns },
                priceWithAddons: this.state.priceWithAddons - parseInt(addOn.price),
                totalItems: this.state.totalItems - 1
            })

            return
        }

        this.setState({
            addOns: { ...this.state.addOns, [addOn.id]: addOn },
            priceWithAddons: this.state.priceWithAddons + parseInt(addOn.price),
            totalItems: this.state.totalItems + 1
        })

    }

    onAddToCartClick = () => {
        const { _addToCart, onClose } = this.props
        console.log("here");

        _addToCart({ addOns: this.state.addOns, priceWithAddons: this.state.priceWithAddons })
        onClose()
        this.clearState()
    }

    render() {
        const { foodItem, onClose, isOpen } = this.props
        return (
            <Dialog
                open={isOpen}
                onClose={onClose}
                aria-labelledby={`AddOns for ${foodItem.title}`}
                aria-describedby={`AddOns for ${foodItem.title}`}
            >
                <DialogTitle id={`ADD ON for ${foodItem.title}`}>{`ADD ON for ${foodItem.title}`}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        {
                            foodItem.customization.map(addOn => {
                                return (
                                    <Grid container key={addOn.id} id={addOn.id}>
                                        <Grid item xs={8}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={!!this.state.addOns[addOn.id]} name={addOn.name}
                                                        onChange={() => { this.toggleAddOn(addOn) }}
                                                    />
                                                }
                                                label={addOn.name}
                                            />
                                        </Grid>
                                        <Grid item xs={4} style={{ "textAlign": "right" }}>
                                            <strong>{addOn.price}</strong>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                        <Grid container>
                            <Grid item xs={6}>
                                <p><strong>{this.state.totalItems}</strong> ADD ON selected</p>
                            </Grid>
                            <Grid item xs={6}>
                                <p style={{ "textAlign": "right" }}>Total Price: <strong>{parseInt(foodItem.price) + parseInt(this.state.priceWithAddons)} </strong> </p>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.onAddToCartClick} color="primary" variant="outlined">
                        Add To Cart
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default AddOnModal